import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { NAME_SOUND_ACTIVE_BANK, useGameSounds, SwipeableDrawer } from "@educaplay/core";
import { SCREENS } from "@educaplay/store/constants";

export default function SwipeableDrawerPoint(props) {
    const { open, onClose, children, className } = props;
    const view = useSelector(state => state.game.view);

    const gameSound = useGameSounds();

    useEffect(() => {
        if (view === SCREENS.SCORE_SCREEN) {
            onClose();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [view])

    useEffect(() => {
        const closeInput = () => {
            if(open) onClose()
        }
        window.addEventListener("map-click", closeInput);
        return () => {
            window.removeEventListener("map-click", closeInput);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])


    useEffect(()=>{
        if(open) gameSound.play(NAME_SOUND_ACTIVE_BANK);
    },[open, gameSound])
    
    return (
        <SwipeableDrawer disableClickOverlay open={open} onClose={onClose} className={className}>
            {children}
        </SwipeableDrawer>
    );
}

SwipeableDrawerPoint.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};